import { AdPosition, BrandSafetyLevels, Viewability } from "../../../types";
import { GEO_CONFIRMATION_MESSAGES, validateGeoCircleRadius, validateGeoConfirmation, validateGeorecencyDuration } from "../../../modules/campaigns/validators/geotargeting";
import { validateCircles } from "../../../modules/campaigns/lineitems/validators/geofence";
const validateGeoCircles = (circles) => validateCircles(circles) || validateGeoCircleRadius(circles);
export const validators = {
    // Whether Brand Safety is required depends on the product, so the form checks that.
    "constraints.brandSafetyLevel": (_scenario, value) => value === undefined || Object.values(BrandSafetyLevels).includes(value)
        ? undefined
        : "Invalid Brand Safety level.",
    "constraints.viewability": (_scenario, value) => value === undefined || Object.values(Viewability).includes(value)
        ? undefined
        : "Invalid viewability.",
    "constraints.adPositions": (_scenario, value) => {
        if (!value?.length) {
            return undefined;
        }
        if (value.some((position) => AdPosition[position] === undefined)) {
            return "Invalid ad position.";
        }
        return new Set(value).size === value.length ? undefined : "Ad positions cannot repeat.";
    },
    "constraints.circles": (_scenario, value) => validateGeoCircles(value),
    "constraints.georecency.circles": (_scenario, value) => validateGeoCircles(value),
    "constraints.georecency.duration": (scenario, value) => validateGeorecencyDuration(scenario.constraints?.georecency?.circles, value),
    "constraints.confirmedRegionalRestrictions": (scenario, value) => validateGeoConfirmation(scenario.constraints?.circles, value, GEO_CONFIRMATION_MESSAGES.confirmedRegionalRestrictions),
    "constraints.confirmedSensitiveCategories": (scenario, value) => validateGeoConfirmation(scenario.constraints?.circles, value, GEO_CONFIRMATION_MESSAGES.confirmedSensitiveCategories),
    "constraints.confirmedDeliveryImpact": (scenario, value) => validateGeoConfirmation(scenario.constraints?.circles, value, GEO_CONFIRMATION_MESSAGES.confirmedDeliveryImpact),
    "constraints.confirmedDataUsage": (scenario, value) => validateGeoConfirmation(scenario.constraints?.georecency?.circles, value, GEO_CONFIRMATION_MESSAGES.confirmedDataUsage),
    "constraints.confirmedHealthcare": (scenario, value) => validateGeoConfirmation(scenario.constraints?.georecency?.circles, value, GEO_CONFIRMATION_MESSAGES.confirmedHealthcare)
};
//# sourceMappingURL=index.js.map